import React from 'react'
import { Alert, Button, Card, CardBody, CardHeader, Spinner, Table } from 'reactstrap'

function CoreEmpresasList({ empresas, isLoading, error, onRefresh }) {
  const safeEmpresas = Array.isArray(empresas) ? empresas : []

  return (
    <Card className="form-card">
      <CardHeader className="form-card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Listado de empresas</h5>
        <Button color="secondary" size="sm" onClick={onRefresh} disabled={isLoading}>
          {isLoading ? 'Cargando...' : 'Refrescar'}
        </Button>
      </CardHeader>
      <CardBody className="form-card-body">
        {error && <Alert color="danger">{error}</Alert>}
        {isLoading ? (
          <div className="d-flex justify-content-center py-3">
            <Spinner color="primary" />
          </div>
        ) : safeEmpresas.length === 0 ? (
          <p className="text-muted mb-0">No hay empresas registradas.</p>
        ) : (
          <Table responsive hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Nombre fiscal</th>
                <th>NIF</th>
                <th>Direccion</th>
                <th>Email</th>
                <th>Dias vacaciones</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {safeEmpresas.map((empresa) => (
                <tr key={empresa.id}>
                  <td>{empresa.id}</td>
                  <td>{empresa.nombre || '-'}</td>
                  <td>{empresa.nombreFiscal || '-'}</td>
                  <td>{empresa.nif || '-'}</td>
                  <td>{empresa.direccion || '-'}</td>
                  <td>{empresa.email || '-'}</td>
                  <td>{empresa.diasVacaciones ?? '-'}</td>
                  <td>{empresa.estado ?? '-'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardBody>
    </Card>
  )
}

export default CoreEmpresasList
